export function isNonEmptyString(text: string | undefined | null): text is string {
  return text !== undefined && text !== null && text.length > 0;
}

export function capitalise(text: string): string {
  return text.replace(
    /(\w)(\w*)/g,
    (_match, firstLetter: string, restOfWord: string) => `${firstLetter.toUpperCase()}${restOfWord}`
  );
}
